// Copyright 2016 Sorama B.V.

import { autoinject } from "aurelia-framework";
import { CreditsMutation, NewCreditsMutation } from "datatypes/SoramaWebApi";
import { IAuthentication } from "libraries/Authentication/IAuthentication";
import { Api } from "libraries/WebApi/Api";
import { IPagedRequest, IPageResult, IWebRequestHandler } from "libraries/WebRequestHandler/IWebRequestHandler";
import { PagedRequest } from "libraries/WebRequestHandler/PagedRequest";
import { Repository } from "repositories/Repository";

@autoinject
export class CreditsBalanceRepository extends Repository {
    private webRequestHandler: IWebRequestHandler;
    private authentication: IAuthentication;

    constructor(webRequestHandler: IWebRequestHandler, authentication: IAuthentication) {
        super();
        this.webRequestHandler = webRequestHandler;
        this.authentication = authentication;
    }

    public getCreditsMutationSetForCreditsBalance(
        id: string,
        odataQuery: string = undefined
    ): IPagedRequest<CreditsMutation> {
        const request = this.webRequestHandler.createGetRequest<IPageResult<CreditsMutation>>(
            Api.creditsBalance + "/" + id + "/CreditsMutationSet" + (odataQuery ? "?" + odataQuery : "")
        );
        return PagedRequest.create<CreditsMutation>(request);
    }

    public getMeasurementCreditSpent(businessUnitId: string, measurementId: string): Promise<number> {
        return this.webRequestHandler
            .createGetRequest<number>(
                Api.creditsBalance + "/" + businessUnitId + "/MeasurementCreditSpent?measurementId=" + measurementId
            )
            .send()
            .then((x) => x.content);
    }

    public getSaldoForCreditsBalance(id: string = null): Promise<number> {
        const buId = id ? id : this.authentication.businessUnitId;

        if (!buId) return Promise.reject<number>("Not Authenticated");

        return this.webRequestHandler
            .createGetRequest<number>(Api.creditsBalance + "/" + buId + "/Saldo")
            .send()
            .then((x) => x.content)
            .catch((e) => this.onError(e));
    }

    /**
     *
     * @param amount the ammount to substract. Should be higher lower than 0.
     * @param description
     */
    public postCreditsDebetAction(amount: number, description: string): Promise<void> {
        if (amount > 0) {
            throw Error("Debet action should be <= 0!");
        }

        const creditsMutation: NewCreditsMutation = {
            amount: Math.ceil(amount),
            description: description,
        };

        const buId = this.authentication.businessUnitId;

        if (!buId) return Promise.reject("Not Authenticated");

        return this.webRequestHandler
            .createPostRequest(Api.creditsBalance + "/" + buId + "/CreditsDebetAction", creditsMutation)
            .send()
            .then(() => {});
    }
}
